import { pick } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { graphql, createFragmentContainer } from 'react-relay';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';

import {
  StoreProvider,
  Label,
  ErrorFlash,
  ImageUploader,
  Dialog,
  ShareableLink,
} from '../../components';
import { updateOffer, endOffer, deleteOffer } from '../../mutations';
import { HOURS } from '../constants';
import 'react-datepicker/dist/react-datepicker.css';
import DatePresenter from '../../presenters/DatePresenter';

export class OfferEditView extends Component {
  constructor(props) {
    super(props);

    const offer = props.offer || {};
    const store = offer.store || {};

    this.state = {
      errors: null,
      submitted: false,
      showsEndOfferDialog: false,
      showsDeletionDialog: false,
      title: offer.title,
      description: offer.description,
      finePrint: offer.finePrint || '',
      storeId: store.id,
      imageUrl: offer.imageUrl || null,
      backgroundImage: null,
      startDate: moment(offer.startDate).startOf('day'),
      startTime: moment(offer.startDate).hour(),
      endDate: moment(offer.endDate).startOf('day'),
      endTime: moment(offer.endDate).hour(),
      isFlash: offer.isFlash || false,
      isPromoted: offer.isPromoted || false,
      isRedeemable: offer.isRedeemable || false,
      isTop: offer.isTop || false,
      isLatest: offer.isLatest || false,
      redemptionCode: offer.redemptionCode || '',
      shareableUrl: offer.shareableUrl,
      appUrl: offer.appUrl,
      isCheckIn: offer.isCheckIn || false,
    };
  }

  notify = (text) =>
    toast.success(text, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

  disableSubmit = () => {
    this.setState({ submitted: 'disabled' });
  };

  enableSubmit = () => {
    this.setState({ errors: null });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.disableSubmit();

    const { offer, relay } = this.props;
    const attributes = pick(this.state, [
      'title',
      'description',
      'finePrint',
      'storeId',
      'backgroundImage',
      'isFlash',
      'isPromoted',
      'isRedeemable',
      'isTop',
      'isLatest',
      'redemptionCode',
      'isCheckIn',
    ]);

    attributes.startDate = moment(this.state.startDate)
      .hour(this.state.startTime)
      .minutes(0)
      .toDate();
    attributes.endDate = moment(this.state.endDate)
      .hour(this.state.endTime)
      .minutes(0)
      .toDate();

    updateOffer(
      relay.environment,
      { id: offer.id, ...attributes },
      {
        onCompleted: this.handleSubmitSuccess,
        onError: this.handleSubmitFailure,
      }
    );
  };

  handleSubmitSuccess = (response) => {
    this.setState({ submitted: false });
    const { errors } = response.updateOffer;
    const isFromBrand = this.props?.location?.state?.isFromBrand || false;
    const router = isFromBrand
      ? `/brands/${this.state.storeId}`
      : `/offers/tab/active/#${response.updateOffer.offer.__id}`;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push(router);
      this.notify('Offer Successfully Changed!');
    }
  };

  handleSubmitFailure = () => {
    this.enableSubmit();
  };

  handleStore = (event) => {
    this.setState({ storeId: event.target.value });
  };

  handleTitle = (event) => {
    this.setState({ title: event.target.value });
  };

  handleDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  handleImageUploaded = (image) => {
    this.setState({ backgroundImage: image });
  };

  handleStartDate = (date) => {
    if (date !== null) {
      this.setState({ startDate: date });
    }
  };

  handleStartTime = (event) => {
    const hour = event.target.value;
    this.setState({ startTime: hour });
  };

  handleEndDate = (date) => {
    if (date !== null) {
      this.setState({ endDate: date });
    }
  };

  handleEndTime = (event) => {
    const hour = event.target.value;
    this.setState({ endTime: hour });
  };

  handleIsFlash = (event) => {
    this.setState({ isFlash: event.target.checked });
  };

  handleIsPromoted = (event) => {
    this.setState({ isPromoted: event.target.checked });
  };

  handleIsRedeemable = (event) => {
    this.setState({ isRedeemable: event.target.checked });
  };

  handleIsLatest = (event) => {
    this.setState({ isLatest: event.target.checked });
  };

  handleIsCheckIn = (event) => {
    this.setState({ isCheckIn: event.target.checked });
  };

  handleIsTop = (event) => {
    this.setState({ isTop: event.target.checked });
  };

  handleRedemptionCode = (event) => {
    this.setState({ redemptionCode: event.target.value });
  };

  handleFinePrint = (event) => {
    this.setState({ finePrint: event.target.value });
  };

  // end offer
  handleEndOffer = () => {
    this.setState({ showsEndOfferDialog: true });
  };

  handleCancelEndOffer = () => {
    this.setState({ showsEndOfferDialog: false });
  };

  handleConfirmEndOffer = () => {
    const today = moment().startOf('day');
    const hourMoment = moment().startOf('hour');

    this.setState({ showsEndOfferDialog: false });
    this.setState({ endDate: today, endTime: hourMoment.hour() });

    const { offer, relay, location } = this.props;
    const attributes = {
      id: offer.id,
      endDate: hourMoment.toDate(),
      isTop: this.state.isTop,
      isCheckIn: this.state.isCheckIn,
    };
    const isFromBrand = location?.state?.isFromBrand || false;
    const router = isFromBrand
      ? `/brands/${this.state.storeId}`
      : `/offers/tab/active`;
    endOffer(relay.environment, attributes, {
      onCompleted: (response) => {
        this.props.history.push(router);
        this.notify('Offer Successfully Ended!');
      },
      onError: (err) => console.error('end offer failed', err),
    });
  };

  // delete offer
  handleDeleteOffer = () => {
    this.setState({ showsDeletionDialog: true });
  };

  handleCancelDeletion = () => {
    this.setState({ showsDeletionDialog: false });
  };

  handleConfirmDeletion = () => {
    this.setState({ showsDeletionDialog: false });

    const { offer, lists, relay, location } = this.props;
    const isFromBrand = location?.state?.isFromBrand || false;
    const router = isFromBrand
      ? `/brands/${this.state.storeId}`
      : `/offers/tab/active`;
    deleteOffer(relay.environment, offer.id, lists.id, {
      onCompleted: () => {
        this.props.history.push(router);
        this.notify('Offer Successfully Deleted!');
      },
      onError: (error) => console.error(`commit failed: ${error}`),
    });
  };

  render() {
    const { offer, location } = this.props;
    const { errors } = this.state;
    const stores = this.props.lists.stores.edges.map((e) => e.node);
    const isFromBrand = location?.state?.isFromBrand || false;

    return (
      <div className="offer-edit">
        <Dialog
          className="end"
          isOpen={this.state.showsEndOfferDialog}
          message="This will expire the offer and remove it from the offer list. Are you sure you want to proceed?"
          onConfirm={this.handleConfirmEndOffer}
          onCancel={this.handleCancelEndOffer}
        />
        <Dialog
          className="deletion"
          isOpen={this.state.showsDeletionDialog}
          message="This will delete the offer and remove it from the offer list. Are you sure you want to proceed?"
          onConfirm={this.handleConfirmDeletion}
          onCancel={this.handleCancelDeletion}
        />

        <form className="offer-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Edit Offer</h2>
            <div className="form-header-actions">
              <div
                id="deleteOffer"
                className="button delete"
                onClick={this.handleDeleteOffer}
              >
                Delete
              </div>
              <Link
                to={{
                  pathname: '/offers/new',
                  state: { offer, isFromBrand },
                }}
                className="button"
              >
                Duplicate Offer
              </Link>
              <Link
                to={{
                  pathname: `/messages/offer/${offer?.id}/new`,
                  state: { isFromBrand, brandId: offer?.store?.id },
                }}
              >
                <button className="button">New Message</button>
              </Link>
              <input
                id="saveOffer"
                className="offer-edit-submit"
                type="submit"
                value="Save"
                disabled={this.state.submitted}
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <div className="store-field">
                    <Label attr="store" text="Brand" errors={errors} />
                    <select
                      id="store"
                      value={this.state.storeId}
                      onChange={this.handleStore}
                    >
                      <option disabled="disabled" value="no-selection">
                        {' '}
                        -- select a brand --{' '}
                      </option>
                      {stores.map((store, i) => (
                        <option value={store.id} key={i}>
                          {store.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="title-field">
                    <Label attr="title" text="Title" errors={errors} />
                    <input
                      type="text"
                      id="title"
                      value={this.state.title}
                      onChange={this.handleTitle}
                      required
                    />
                  </div>

                  <div className="description-field">
                    <Label
                      attr="description"
                      text="Description"
                      errors={errors}
                    />
                    <textarea
                      id="description"
                      value={this.state.description}
                      onChange={this.handleDescription}
                    />
                  </div>

                  <div className="fine-print-field">
                    <Label attr="finePrint" text="Fine Print" errors={errors} />
                    <textarea
                      id="finePrint"
                      value={this.state.finePrint}
                      onChange={this.handleFinePrint}
                    />
                  </div>

                  <div className="is-flash-field checkbox">
                    <input
                      type="checkbox"
                      id="isFlash"
                      checked={this.state.isFlash}
                      onChange={this.handleIsFlash}
                    />
                    <Label attr="isFlash" text="Is Flash" errors={errors} />
                  </div>

                  <div className="is-promoted-field checkbox">
                    <input
                      type="checkbox"
                      id="isPromoted"
                      checked={this.state.isPromoted}
                      onChange={this.handleIsPromoted}
                    />
                    <Label
                      attr="isPromoted"
                      text="Is Promoted"
                      errors={errors}
                    />
                  </div>
                  <div className="isTop-field checkbox">
                    <input
                      type="checkbox"
                      id="isTop"
                      checked={this.state.isTop}
                      onChange={this.handleIsTop}
                    />
                    <Label attr="isTop" text="Is A Top Offer" errors={errors} />
                  </div>
                  <div className="isLatest-field checkbox">
                    <input
                      type="checkbox"
                      id="isLatest"
                      checked={this.state.isLatest}
                      onChange={this.handleIsLatest}
                    />
                    <Label
                      attr="isLatest"
                      text="Is A Latest Offer"
                      errors={errors}
                    />
                  </div>
                  <div className="is-check-in-field checkbox">
                    <input
                      type="checkbox"
                      id="isCheckIn"
                      checked={this.state.isCheckIn}
                      onChange={this.handleIsCheckIn}
                    />
                    <Label
                      attr="isCheckIn"
                      text="Is Check-In Offer"
                      errors={errors}
                    />
                  </div>
                  <div>
                    <ShareableLink
                      name="shareableLink"
                      title="Shareable Link"
                      url={offer?.shareableUrl}
                    />
                  </div>
                  <div>
                    <ShareableLink
                      name="appUrl"
                      title="App Link"
                      url={offer?.appUrl}
                    />
                  </div>
                </div>

                <div className="form-group-column">
                  <div className="input image-upload">
                    <Label attr="image" text="Image" errors={errors} />
                    <div className="image-upload-hint">
                      Image should be a .png or .jpg and have an aspect ratio of
                      15:13 (e.g. 750w x 650h)
                    </div>
                    <ImageUploader
                      id="backgroundImage"
                      type="offer"
                      source={this.state.imageUrl}
                      onUploaded={this.handleImageUploaded}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <h3>Availability</h3>
              <div className="availability">
                <div className="availability-field start-date">
                  <Label attr="startDate" text="Start Date" errors={errors} />
                  <DatePicker
                    id="startDate"
                    selected={DatePresenter.dateObject(this.state.startDate)}
                    onChange={(date) => this.handleStartDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field start-time">
                  <div>
                    <Label attr="startTime" text="Start Time" />
                    <select
                      id="startTime"
                      value={this.state.startTime}
                      onChange={this.handleStartTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="availability-field end-date">
                  <Label attr="endDate" text="End Date" errors={errors} />
                  <DatePicker
                    id="endDate"
                    selected={DatePresenter.dateObject(this.state.endDate)}
                    onChange={(date) => this.handleEndDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field end-time">
                  <div>
                    <Label attr="endTime" text="End Time" />
                    <select
                      id="endTime"
                      value={this.state.endTime}
                      onChange={this.handleEndTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <a onClick={this.handleEndOffer}>End Now</a>
              </div>
            </div>

            <div className="form-group">
              <h3>Redemption</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <div className="redemption-code-field">
                    <Label
                      attr="redemptionCode"
                      text="Redemption Code"
                      errors={errors}
                    />
                    <input
                      id="redemptionCode"
                      value={this.state.redemptionCode}
                      onChange={this.handleRedemptionCode}
                    />
                  </div>

                  <div className="is-redeemable-field checkbox">
                    <input
                      type="checkbox"
                      id="isRedeemable"
                      checked={this.state.isRedeemable}
                      onChange={this.handleIsRedeemable}
                    />
                    <Label
                      attr="isRedeemable"
                      text="Is Redeemable"
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const OfferEditContainer = withRouter(
  createFragmentContainer(OfferEditView, {
    offer: graphql`
      fragment OfferEdit_offer on Offer {
        id
        title
        description
        store {
          id
        }
        imageUrl
        startDate
        endDate
        isFlash
        isLatest
        isPromoted
        isRedeemable
        isCheckIn
        redemptionCode
        finePrint
        isTop
        shareableUrl
        appUrl
      }
    `,
    lists: graphql`
      fragment OfferEdit_lists on Lists {
        id
        stores(first: 1000) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  })
);

export default class OfferEdit extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={OfferEditContainer}
        query={graphql`
          query OfferEditQuery($offerId: ID!) {
            lists {
              ...OfferEdit_lists
            }

            offer(id: $offerId) {
              ...OfferEdit_offer
            }
          }
        `}
      />
    );
  }
}
